import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
  PrintTestSection,
  TikZType,
  generatedQuestionObj,
  options,
  saveTestStruct,
  subTopicByScoringAndTestId,
  subTopicQuestionDetailNew,
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { NgZone } from '@angular/core';

declare var update: any;

@Component({
  selector: 'app-print-test',
  templateUrl: './print-test.component.html',
  styleUrls: ['./print-test.component.scss'],
})
export class PrintTestComponent implements OnInit {
  paramSubscription: Subscription = new Subscription();
  sectionBehaviourSubject: BehaviorSubject<number> = new BehaviorSubject(0);
  recievedTestTypeId: number = -1;
  recievedTestId: number = -1;
  recievedTest: saveTestStruct | undefined = undefined;

  scoringSectionWithSubTopics: {
    [key: string | number]: subTopicByScoringAndTestId[];
  } | null = null;

  printSections: PrintTestSection[] = [];

  showAllModules: boolean = true;
  showExplanations: boolean = true;
  showAnswers: boolean = true;
  showQuestionInfo: boolean = true;
  allModulesHidden: boolean = false;
  printDisabled: boolean = true;
  isDataLoading: boolean = false;

  options = options;

  difficultyLevels = [
    {
      level: 1,
      name: 'easy',
    },
    {
      level: 2,
      name: 'medium',
    },
    {
      level: 3,
      name: 'hard',
    },
  ];

  images: any = null;
  numberOfTotalTikz: number = 0;
  totaltikZ: TikZType[] = [];

  notifier: NotifierService;

  constructor(
    private globalApiService: GlobalApiService,
    private activateRoute: ActivatedRoute,
    private ngZone: NgZone,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.getTestIdParams();
  }

  getTestIdParams() {
    this.paramSubscription = this.activateRoute.params.subscribe(
      (testIdSubscription) => {
        console.log(testIdSubscription);
        this.recievedTestId = testIdSubscription['testId'];
        this.recievedTestTypeId = testIdSubscription['testTypeId'];
        if (
          this.recievedTestId !== -1 &&
          this.recievedTestId !== undefined &&
          this.recievedTestId !== null
        ) {
          this.getTest(this.recievedTestId);
        } else {
          console.log('Invalid test ID');
          this.notifier.notify('error', 'Invalid test ID');
        }
      }
    );
  }

  getTest(testId: number) {
    this.globalApiService.getCreatedTest(testId).subscribe({
      next: (res: saveTestStruct) => {
        // console.log('getTest Response: ', res);
        this.isDataLoading = true;
        this.printDisabled = true;
        this.recievedTest = res;
        this.recievedTest.testModuleDetails.sort((a, b) => {
          return a.moduleOrder - b.moduleOrder;
        });
        console.log('recieved Test --> : ', this.recievedTest);
        this.recievedTest.testModuleDetails.forEach(
          (testModule, testModuleIndex) => {
            this.addPrintSection();
            this.fillRecievedTestDetails(testModuleIndex);
          }
        );
        this.paramSubscription.unsubscribe();
      },
      error: (err) => {
        console.log('getTest Error: ', err);
        this.notifier.notify('error', 'Unable to get test');
        this.isDataLoading = false;
      },
    });
  }

  getSubTopicsByScoringAndTestId(sectionIndex: number) {
    const printSection = this.printSections[sectionIndex];
    let getSubTopics = true;
    if (
      this.scoringSectionWithSubTopics &&
      this.scoringSectionWithSubTopics[printSection.sectionType]
    ) {
      getSubTopics = false;
    }
    if (getSubTopics) {
      console.log(printSection.sectionType);
      this.globalApiService
        .getSubTopicsByScoringAndTestId(
          printSection.sectionType as number,
          this.recievedTestTypeId
        )
        .subscribe({
          next: (res: subTopicByScoringAndTestId[]) => {
            console.log(res);
            if (this.scoringSectionWithSubTopics) {
              this.scoringSectionWithSubTopics[printSection.sectionType] = res;
            } else {
              this.scoringSectionWithSubTopics = {
                [printSection.sectionType]: res,
              };
            }
            console.log(this.scoringSectionWithSubTopics);
            this.getAndReplaceQuestionIdsWithQuestions(sectionIndex);
          },
          error: (err) => {
            // console.log(err);
            this.notifier.notify('error', 'Unable to fetch subtopics');
          },
        });
    }
  }

  addPrintSection() {
    const printSectionObj: PrintTestSection = {
      sectionName: '',
      sectionType: 0,
      questions: [],
      isPrintAllowed: true,
    };
    this.printSections.push(printSectionObj);
  }

  fillRecievedTestDetails(printSectionIndex: number) {
    this.printSections[printSectionIndex].sectionName =
      this.recievedTest!.testModuleDetails[printSectionIndex].moduleName;
    this.printSections[printSectionIndex].sectionType =
      this.recievedTest!.testModuleDetails[printSectionIndex].scoringSectionId;
    this.getSubTopicsByScoringAndTestId(printSectionIndex);
  }

  // sortByModuleOrder() {
  //   this.recievedTest?.testModuleDetails.sort((a, b) => {
  //     return a.moduleOrder - b.moduleOrder;
  //   });
  // }

  getAndReplaceQuestionIdsWithQuestions(printSectionIndex: number) {
    // const test = this.recievedTest;
    let count = 0;
    // test?.testModuleDetails.sort((a, b) => {
    //   return a.moduleOrder - b.moduleOrder;
    // });
    const testModule = this.recievedTest?.testModuleDetails[printSectionIndex];
    console.log(testModule);
    // test?.testModuleDetails.forEach((testModule, testModuleIndex) => {
    let questionIdsArr: number[] = [];
    let subTopicQuestionDetailCompareArr: any[] = [];
    let subTopicQuestionDetailArr: subTopicQuestionDetailNew[] = [];
    let joinedQuestionIds: string = '';
    testModule?.questionsInfo.forEach(
      (questionInfoObj, questionInfoObjIndex) => {
        if (questionInfoObj.questionOrder === questionInfoObjIndex + 1) {
          let subTopicQuestionDetailCompareObj: any = {
            questionDetails: undefined,
            subTopicId: questionInfoObj.subTopicId,
            questionType: 0,
            difficultLevel: questionInfoObj.difficultyLevel,
            questionId: questionInfoObj.questionId,
          };
          subTopicQuestionDetailCompareArr.push(
            subTopicQuestionDetailCompareObj
          );
          questionIdsArr.push(questionInfoObj.questionId);
        }
      }
    );
    joinedQuestionIds = questionIdsArr.join(',');
    console.log(joinedQuestionIds);
    count = count + 1;
    this.globalApiService.getMultipleQuestions(joinedQuestionIds).subscribe({
      next: (res: generatedQuestionObj[]) => {
        console.log('recieved questions: ', res);
        testModule!.recievedQuestions = res;
        const orderedReceivedQuestions: generatedQuestionObj[] = [];
        testModule?.questionsInfo.forEach((questionInfoObj) => {
          const resQuestionIndex = res.findIndex((resObj) => {
            return questionInfoObj.questionId === resObj.question.questionId;
          });
          if (resQuestionIndex >= 0) {
            orderedReceivedQuestions.push(res[resQuestionIndex]);
          }
        });
        console.log(orderedReceivedQuestions);
        orderedReceivedQuestions.forEach(
          (orderedReceivedQuestion, orderedReceivedQuestionIndex) => {
            subTopicQuestionDetailCompareArr.forEach(
              (subTopicQuestionCompDetail, subTpicQUestionCompDetailIndex) => {
                if (
                  orderedReceivedQuestion.question.questionId ===
                  subTopicQuestionCompDetail.questionId
                ) {
                  console.log(
                    this.printSections[printSectionIndex].sectionType
                  );
                  let subTopicList =
                    this.scoringSectionWithSubTopics![
                      this.printSections[printSectionIndex].sectionType
                    ];
                  console.log(subTopicList);
                  let foundSubTopic = subTopicList.find(
                    (subTopic) =>
                      subTopic.subTopicId ===
                      subTopicQuestionCompDetail.subTopicId
                  );
                  let subTopicQuestionDetailObj: subTopicQuestionDetailNew = {
                    questionDetails: orderedReceivedQuestion,
                    subTopicId: subTopicQuestionCompDetail.subTopicId,
                    questionType: orderedReceivedQuestion.question.questionType,
                    difficultLevel: subTopicQuestionCompDetail.difficultLevel,
                  };
                  subTopicQuestionDetailObj.subTopicName = foundSubTopic
                    ? foundSubTopic.subTopicName.length > 0
                      ? foundSubTopic.subTopicName
                      : 'N/A'
                    : 'N/A';
                  subTopicQuestionDetailArr.push(subTopicQuestionDetailObj);
                }
              }
            );
          }
        );
        testModule!.recievedQuestions = orderedReceivedQuestions;
        res.forEach((resObj, resobjIndex) => {
          testModule?.questionsInfo.forEach(
            (questionInfoObj, questionInfoObjIndex) => {
              if (resObj.question.questionId === questionInfoObj.questionId) {
                resObj.moduleQuestionId = questionInfoObj.moduleQuestionId;
              }
            }
          );
        });
        // this.generatedDisplayModules[testModuleIndex].generatedQuestions = res;
        this.printSections[printSectionIndex].questions =
          subTopicQuestionDetailArr;

        // this.printSections[printSectionIndex].questions.forEach(
        //   (question, questionIndex) => {
        //     // if ( question.questionType === 1) {
        //     //   question.questionDetails.choices.
        //     // }
        //     // if (this.totaltikZ.length < 6) {
        // this.loadTikzPerQuestion(printSectionIndex, questionIndex);
        //    // }
        //   }
        // );

        // testModule.subTopicQuestionDetails.forEach(
        //   (subTopicDetail, subTopicDetailIndex) => {
        //     subTopicDetail.questionSpecifications.forEach(
        //       (questionSpec, questionSpecIndex) => {
        //         questionSpec['questions'] = [];
        //         this.printSections[testModuleIndex].questions.forEach(
        //           (recievedQuestion, recievedQuestionIndex) => {
        //             console.log(recievedQuestion);
        //             if (
        //               subTopicDetail.subTopicId ===
        //                 recievedQuestion.subTopicId &&
        //               questionSpec.difficultLevel ===
        //                 recievedQuestion.difficultLevel &&
        //               questionSpec.questionType ===
        //                 recievedQuestion.questionType
        //             ) {
        //               const subTopicQuestionDetailObj: subTopicQuestionDetailNew =
        //                 {
        //                   questionDetails: recievedQuestion.questionDetails,
        //                   subTopicId: recievedQuestion.subTopicId,
        //                   questionType: recievedQuestion.questionType,
        //                   difficultLevel: recievedQuestion.difficultLevel,
        //                   subTopicName: recievedQuestion.subTopicName,
        //                 };
        //               questionSpec.questions?.push(subTopicQuestionDetailObj);
        //             }
        //             // this.ngZone.run(() => {
        //             // this.loadTikz();
        //             // });
        //           }
        //         );
        //       }
        //     );
        //   }
        // );
        this.loadTikz();
        this.makeImages();
        console.log(res);
        console.log(testModule);
        this.isDataLoading = false;
        this.printDisabled = false;
      },
      error: (err) => {
        console.log('recieved questions Error: ', err);
        this.isDataLoading = false;
      },
    });
    // });
    // this.sectionBehaviourSubject.subscribe((yo) => {
    //   console.log(yo);
    //   if (yo === 1) {
    //     this.makeImages();
    //     this.loadTikz();
    //   }
    // });
    console.log(count);
    console.log(this.recievedTest);
    console.log(this.printSections);
  }

  delayTikz(index: number, totaltikZ: TikZType[]) {
    setTimeout(() => {
      console.log(index, totaltikZ[index]);
      new update(totaltikZ[index].data, totaltikZ[index].id);
      index++;
      if (index < totaltikZ.length) {
        this.delayTikz(index, totaltikZ);
      }
      // this.isDataLoading = false;
    }, 1000);
  }

  // loadTikz() {
  loadTikzPerQuestion(printSectionIndex: number, questionIndex: number) {
    // this.isDataLoading = true;
    // const totaltikZ: TikZType[] = [];
    // this.printSections.forEach((printSection, printSectionIndex) => {
    //   printSection.questions.forEach((question, questionIndex) => {
    let question =
      this.printSections[printSectionIndex].questions[questionIndex];
    // ** tikz for questions
    question.questionDetails.question.questionData.forEach(
      (questionInfo, questionInfoIndex) => {
        if (questionInfo.type === 'TikZ') {
          this.totaltikZ.push({
            id:
              'printQuestion-' +
              printSectionIndex +
              '-' +
              questionIndex +
              '-' +
              questionInfoIndex,
            data: questionInfo.data,
          });
        }
      }
    );
    if (question.questionType === 1) {
      // ** tikz for choices (options and explanations
      question.questionDetails.choices?.forEach((mcqChoice, mcqChoiceIndex) => {
        // ** tikz for choice options and answers
        mcqChoice.optionValue.forEach(
          // ** tikz for choices options
          (mcqChoiceOption, mcqChoiceOptionIndex) => {
            if (mcqChoiceOption.type === 'TikZ') {
              this.totaltikZ.push({
                id:
                  'printChoiceOption-' +
                  printSectionIndex +
                  '-' +
                  questionIndex +
                  '-' +
                  mcqChoiceIndex +
                  '-' +
                  mcqChoiceOptionIndex,
                data: mcqChoiceOption.data,
              });
            }
            // ** tikz for choices answers
            if (mcqChoice.isAnswer) {
              if (mcqChoiceOption.type === 'TikZ') {
                this.totaltikZ.push({
                  id:
                    'printChoiceAnswer-' +
                    printSectionIndex +
                    '-' +
                    questionIndex +
                    '-' +
                    mcqChoiceIndex +
                    '-' +
                    mcqChoiceOptionIndex,
                  data: mcqChoiceOption.data,
                });
              }
            }
          }
        );
        // ** tikz for explanations in choices
        mcqChoice.explanation?.forEach(
          (mcqChoiceExplanation, mcqChoiceExplanationIndex) => {
            if (mcqChoiceExplanation.type === 'TikZ') {
              this.totaltikZ.push({
                id:
                  'printChoiceExplanation-' +
                  printSectionIndex +
                  '-' +
                  questionIndex +
                  '-' +
                  mcqChoiceIndex +
                  '-' +
                  mcqChoiceExplanationIndex,
                data: mcqChoiceExplanation.data,
              });
            }
          }
        );
      });
    }
    if (question.questionType === 2) {
      // ** tikz for freetext answer - explanations
      question.questionDetails.answers?.explanation?.forEach(
        (freetextExplanation, freetextExplanationIndex) => {
          if (freetextExplanation.type === 'TikZ') {
            this.totaltikZ.push({
              id:
                'printFreetextExplanation-' +
                printSectionIndex +
                '-' +
                questionIndex +
                '-' +
                freetextExplanationIndex,
              data: freetextExplanation.data,
            });
          }
        }
      );
    }
    //   });
    // });
    // this.sectionBehaviourSubject.next(0);
    console.log(this.totaltikZ);
    if (this.totaltikZ.length > 0) {
      setTimeout(() => {
        this.delayTikz(0, this.totaltikZ);
      }, 1000);
    }
  }

  loadTikz() {
    // this.isDataLoading = true;
    const totaltikZ: TikZType[] = [];
    this.printSections.forEach((printSection, printSectionIndex) => {
      printSection.questions.forEach((question, questionIndex) => {
        // let question =
        //   this.printSections[printSectionIndex].questions[questionIndex];
        // ** tikz for questions
        question.questionDetails.question.questionData.forEach(
          (questionInfo, questionInfoIndex) => {
            if (questionInfo.type === 'TikZ') {
              totaltikZ.push({
                id:
                  'printQuestion-' +
                  printSectionIndex +
                  '-' +
                  questionIndex +
                  '-' +
                  questionInfoIndex,
                data: questionInfo.data,
              });
            }
          }
        );
        if (question.questionType === 1) {
          // ** tikz for choices (options and explanations
          question.questionDetails.choices?.forEach(
            (mcqChoice, mcqChoiceIndex) => {
              // ** tikz for choice options and answers
              mcqChoice.optionValue.forEach(
                // ** tikz for choices options
                (mcqChoiceOption, mcqChoiceOptionIndex) => {
                  if (mcqChoiceOption.type === 'TikZ') {
                    totaltikZ.push({
                      id:
                        'printChoiceOption-' +
                        printSectionIndex +
                        '-' +
                        questionIndex +
                        '-' +
                        mcqChoiceIndex +
                        '-' +
                        mcqChoiceOptionIndex,
                      data: mcqChoiceOption.data,
                    });
                  }
                  // ** tikz for choices answers
                  if (mcqChoice.isAnswer) {
                    if (mcqChoiceOption.type === 'TikZ') {
                      totaltikZ.push({
                        id:
                          'printChoiceAnswer-' +
                          printSectionIndex +
                          '-' +
                          questionIndex +
                          '-' +
                          mcqChoiceIndex +
                          '-' +
                          mcqChoiceOptionIndex,
                        data: mcqChoiceOption.data,
                      });
                    }
                  }
                }
              );
              // ** tikz for explanations in choices
              mcqChoice.explanation?.forEach(
                (mcqChoiceExplanation, mcqChoiceExplanationIndex) => {
                  if (mcqChoiceExplanation.type === 'TikZ') {
                    totaltikZ.push({
                      id:
                        'printChoiceExplanation-' +
                        printSectionIndex +
                        '-' +
                        questionIndex +
                        '-' +
                        mcqChoiceIndex +
                        '-' +
                        mcqChoiceExplanationIndex,
                      data: mcqChoiceExplanation.data,
                    });
                  }
                }
              );
            }
          );
        }
        if (question.questionType === 2) {
          // ** tikz for freetext answer - explanations
          question.questionDetails.answers?.explanation?.forEach(
            (freetextExplanation, freetextExplanationIndex) => {
              if (freetextExplanation.type === 'TikZ') {
                totaltikZ.push({
                  id:
                    'printFreetextExplanation-' +
                    printSectionIndex +
                    '-' +
                    questionIndex +
                    '-' +
                    freetextExplanationIndex,
                  data: freetextExplanation.data,
                });
              }
            }
          );
        }
      });
    });
    // this.sectionBehaviourSubject.next(0);
    console.log(totaltikZ);
    this.totaltikZ = totaltikZ;
    if (totaltikZ.length > 0) {
      setTimeout(() => {
        this.delayTikz(0, totaltikZ);
      }, 1000);
    }
  }

  triggerCompleteTikz(trigger: number, printSectionIndex?: number) {
    console.log(this.showExplanations);
    let totalTikz: TikZType[] = this.totaltikZ.slice();
    if (!this.showAllModules) {
      this.printSections.forEach((printSection, printSectionIndex) => {
        console.log(printSection, printSectionIndex);
        if (!printSection.isPrintAllowed) {
          totalTikz = totalTikz.filter(
            (tikzEle) =>
              tikzEle.id.split('-')[1] !== printSectionIndex.toString()
          );
        }
      });
    }
    if (trigger === 1 && this.showExplanations) {
      totalTikz = totalTikz.filter((tikzEle) =>
        tikzEle.id.includes('Explanation')
      );
    } else if (trigger === 2 && this.showAnswers) {
      totalTikz = totalTikz.filter((tikzEle) => tikzEle.id.includes('Answer'));
    } else if (trigger === 3) {
      let printSection = this.printSections[printSectionIndex!];
      if (printSection.isPrintAllowed) {
        totalTikz = totalTikz.filter(
          (tikzEle) =>
            tikzEle.id.split('-')[1] === printSectionIndex?.toString()
        );
        if (!this.showExplanations && !this.showAnswers) {
          totalTikz = totalTikz.filter(
            (tikzEle) =>
              !tikzEle.id.includes('Explanation') ||
              !tikzEle.id.includes('Answer')
          );
        } else if (!this.showExplanations) {
          totalTikz = totalTikz.filter(
            (tikzEle) => !tikzEle.id.includes('Explanation')
          );
        } else if (!this.showAnswers) {
          totalTikz = totalTikz.filter(
            (tikzEle) => !tikzEle.id.includes('Answer')
          );
        }
      }
    }
    console.log(totalTikz);
    if (totalTikz.length > 0) {
      setTimeout(() => {
        this.delayTikz(0, totalTikz);
      }, 1000);
    }
  }

  getImages(listOfImages: string[]) {
    this.globalApiService.getImages(listOfImages).subscribe(
      (response: any) => {
        console.log(response);
        const data = response.data;
        if (data) {
          this.images = { ...this.images, ...data };
        }
        console.log(this.images);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  makeImages() {
    let listOfImages: string[] = [];
    this.printSections.forEach((printSection) => {
      printSection.questions.forEach((questionsObj) => {
        // ** For choices (MCQ's)
        questionsObj.questionDetails.choices?.forEach((choice) => {
          // ** For choices (Explanations)
          choice.explanation?.forEach((explanation) => {
            if (explanation.type === 'Images') {
              explanation['images'] = JSON.parse(explanation.data);
              listOfImages.push(...(explanation['images'] as string[]));
            }
          });
          // ** For choices Options
          choice.optionValue.forEach((choiceData) => {
            if (choiceData.type === 'Images') {
              choiceData['images'] = JSON.parse(choiceData.data);
              listOfImages.push(...(choiceData['images'] as string[]));
            }
          });
        });
        // ** For answers (Freetext) - Explanaions
        questionsObj.questionDetails.answers?.explanation.forEach(
          (freetextExplanation) => {
            if (freetextExplanation.type === 'Images') {
              freetextExplanation['images'] = JSON.parse(
                freetextExplanation.data
              );
              listOfImages.push(...(freetextExplanation['images'] as string[]));
            }
          }
        );
        // ** For questions
        questionsObj.questionDetails.question.questionData.forEach(
          (questionDataObj) => {
            if (questionDataObj.type === 'Images') {
              questionDataObj['images'] = JSON.parse(questionDataObj.data);
              listOfImages.push(...(questionDataObj['images'] as string[]));
            }
          }
        );
      });
    });
    this.getImages(listOfImages);
  }

  checkPrintSections(isToogle: boolean, printSectionIndex?: number) {
    if (isToogle) {
      if (!this.showAllModules) {
        for (
          let printSectionIndex = 0;
          printSectionIndex < this.printSections.length;
          printSectionIndex++
        ) {
          if (this.printSections[printSectionIndex].isPrintAllowed) {
            this.allModulesHidden = false;
          }
          break;
        }
      } else {
        this.allModulesHidden = false;
        this.printSections.forEach((printSection, printSectionIndex) => {
          printSection.isPrintAllowed = true;
        });
      }
    } else {
      let printState = this.printSections.find((printSection) => {
        return printSection.isPrintAllowed;
      });
      if (printState) {
        this.allModulesHidden = false;
      } else {
        this.allModulesHidden = true;
      }
      console.log(printSectionIndex);
      if (printSectionIndex !== undefined && printSectionIndex >= 0) {
        console.log('triggered');
        this.triggerCompleteTikz(3, printSectionIndex);
      }
    }
  }

  print() {
    window.print();
  }
}
